import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-black bg-opacity-80 w-full h-screen flex justify-center items-center absolute" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {"border-top-color":"transparent"},
  class: "w-16 h-16 border-4 border-indigo-300 border-solid rounded-full animate-spin"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}